import {Component, EventEmitter, Inject, Input, LOCALE_ID, OnInit, Output} from '@angular/core';
import {Planning, PlanningCategorieCours, TypeCours} from "../../../suaps/common/services/planning/plannig.model";
import {PlanningService} from "../../../suaps/common/services/planning/planning.service";
import {StateSubscription, Subscription} from "../../../suaps/common/services/subscription/subscription.model";
import {Individu} from "@Common/core/services";
import {SubscriptionService} from "../../../suaps/common/services/subscription/subscription.service";

@Component({
  selector: 'app-activity',
  templateUrl: './activity.component.html',
  styleUrls: ['./activity.component.scss']
})
export class ActivityComponent implements OnInit {

  @Input() activity: Planning;
  @Input() connecte: Individu;
  @Output() openDetail = new EventEmitter<Planning>();
  typeCours = TypeCours;
  categoreCours = PlanningCategorieCours;
  stateSubscription = StateSubscription;
  extraParams: Map<string, string> = new Map<string, string>();
  mySubscription: Subscription = <Subscription>{id: 0};

  constructor(public planningSvc: PlanningService,
              private subscriptionSvc: SubscriptionService) { }

  ngOnInit(): void {
    this._getMySubscription();
  }

  limitContent(content: string, limit: number): string {
    const end = (content?.length > limit ? '...' : '');
    return `${content.substring(0, limit)}${end}`;
  }

  openActivity(): void {
    this.openDetail.emit(this.activity);
  }
  displayState(state: number): string {
    return this.subscriptionSvc.displayState(state);
  }

  displayCategorieCours(): string {
    if (this.activity.type_cours === this.typeCours.stage) {
      if (this.activity.categorie_cours === this.categoreCours.ec_libre) {
        return 'Intensif EC';
      }
      if (this.activity.categorie_cours === this.categoreCours.les_deux) {
        return 'Intensif EC et loisir';
      }
    }
    return this.activity.categorie_cours_label;
  }

  private _getMySubscription(): void {
    this.mySubscription = this.subscriptionSvc.getMySubscription(this.activity.subscriptions_obj, this.connecte);
  }

}
